module.exports = __webpack_public_path__ + "static/media/4.7c12401e.png";